import {
  GET_MESSAGE_COST_REQUEST,
  POST_TEXT_MESSAGE_REQUEST,
  GET_MESSAGE_COST_SUCCESS,
  POST_TEXT_MESSAGE_SUCCESS,
  GET_MESSAGE_COST_FAILURE,
  POST_TEXT_MESSAGE_FAILURE
} from 'actions/api/messaging'

export const initialState = {
  freeMessages: 0,
  balance: 0,
  cost: 0,
  loading: false,
  costError: null,
  sendError: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MESSAGE_COST_REQUEST: {
      return {
        ...state,
        loading: true,
        costError: null
      }
    }
    case POST_TEXT_MESSAGE_REQUEST: {
      return {
        ...state,
        loading: true,
        sendError: null
      }
    }
    case GET_MESSAGE_COST_SUCCESS: {
      return {
        ...state,
        loading: false,
        freeMessages: action.response.free_msg_credit,
        balance: action.response.balance,
        cost: action.response.cost
      }
    }
    case POST_TEXT_MESSAGE_SUCCESS: {
      return {
        ...state,
        loading: false
      }
    }
    case GET_MESSAGE_COST_FAILURE: {
      return {
        ...state,
        loading: false,
        costError: {
          error: action.error,
          errorDetails: action.errorDetails
        }
      }
    }
    case POST_TEXT_MESSAGE_FAILURE: {
      return {
        ...state,
        loading: false,
        sendError: {
          error: action.error,
          errorDetails: action.errorDetails
        }
      }
    }
  }
  return state
}
